import {InfoIcon} from "lucide-react";

import {GeneralSettingsFormFields} from "./GeneralSettingsFormFields";

export const QuickAssistantSetupGeneralSettingsSection = () => {
  return (
    <div className="flex flex-col gap-4">
      <GeneralSettingsFormFields />

      <div>
        <div className="flex items-center gap-2 text-sm text-secondary">
          <InfoIcon className="w-[18px] h-[18px]" /> You will be able to
          customize more options after the agent has been created
        </div>
      </div>
    </div>
  );
};
